import { DocumentMeta } from '../meta';
import { AmortizationStatus } from '../static';
import { TitleState } from './state';

export interface Amortization {
  _meta?: DocumentMeta;
  id: string;
  waterfallId: string;
  name: string;
  contractIds: string[];
  status: AmortizationStatus;
  filmCost: number;
  financing: number;
  poolName: string;
}

export type AmortizationDetails = Amortization & { restToBeAmortized: number, currentValue: number };

export function createAmortization(params: Partial<Amortization>): Amortization {
  return {
    id: '',
    status: 'draft',
    name: '',
    waterfallId: '',
    contractIds: [],
    filmCost: 0,
    financing: 0,
    poolName: '',
    ...params
  };
}

/**
 * 
 * @param contractId 
 * @param amortizations 
 * @param state 
 * @returns 
 */
export function getAmortizationDetails(
  contractId: string,
  amortizations: Amortization[],
  state: TitleState,
): AmortizationDetails {

  const amortization = amortizations.find(a => a.contractIds.includes(contractId));
  if (!amortization) return undefined;
  const amortizationState = state.amortizations[amortization.id];
  if (!amortizationState) return undefined;
  const pool = state.pools[amortizationState.poolId];
  if (!pool) return undefined;
  const currentValue = pool.turnover.calculated;
  const rest = amortizationState.filmCost - (currentValue + amortizationState.financing);
  const restToBeAmortized = rest <= 0 ? 0 : rest;
  return { restToBeAmortized, currentValue, ...amortization };
}

